import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CandidateSourcing from './CandidateSourcing';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function CandidateSourcingPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <CandidateSourcing />
    </QueryClientProvider>
  );
} 
